import { render, staticRenderFns } from "./IconPlus.vue?vue&type=template&id=0935923c&"
import script from "./IconPlus.vue?vue&type=script&lang=ts&"
export * from "./IconPlus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports